<template>
  <span>
    <button class="btn btn-block-mobile btn-primary-outline" v-b-modal.programme-modal>
      {{ trans('agencies.delete') }}
    </button>
    <b-modal id="programme-modal" hide-header body-class="pb-5 pt-0">
      <template v-slot:default>
        <div class="row bg-light-blue">
          <div class="col-lg-12">
            <div class="p-3">
              <h3 class="font-green d-none d-sm-block d-md-block">{{ trans('agencies.delete') }}</h3>
              <h4 class="d-block d-sm-none font-green">{{ trans('programme.quit') }}</h4>
            </div>
          </div>
        </div>
        <div class="row py-5 px-3">
          <div class="col-lg-12">
            <p>{{ trans('programme.confirm_delete_text') }} <br /><b>{{ agency_name }}</b></p>
          </div>
        </div>
      </template>
      <template v-slot:modal-footer="{ cancel }">
        <button
          type="button"
          class="btn mr-3"
          @click="cancel()"
        >{{ trans('programme.quit_modal_cancel_btn') }}</button>
        <button
          type="button"
          class="btn btn-primary px-5"
          @click="handleOk()"
        >{{ trans('programme.modal_delete_btn') }}</button>
      </template>
    </b-modal>
  </span>
</template>

<script>
export default {
  props: ["agency_id", "agency_name"],
  methods: {
    handleOk() {
      this.submit_store();
    },
    async submit_store() {
      let loader = this.$loading.show();
      try {
        const { data } = await axios.delete(route("api.agencies.destroy", this.agency_id));
        window.location.href = route("en.agencies.index");
      } catch (e) {
        loader.hide();
        console.log(e);
        // this.errorPopup(e.response.data.message);
      }
    },
  },
};
</script>
